<template>
	<div class="dropdown">
		<div class="dropdown-title" @click="isShown = !isShown" :class="{shown: isShown}">
			<div class="dropdown-arrow">v</div>
			{{ title }}
		</div>
		<div v-show="isShown" :class="['dropdown-container', containerClass, {right: title === 'Ship'}]">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Dropdown',

	data()
	{
		return {
			isShown: false,
		}
	},
	props: {
		title: {
			type: String
		},
		containerClass: {
			type: String,
			default: ''
		}
	},
	methods: {
		clickOutside(event) {
			if (!this.$el.contains(event.target))
				this.isShown = false;
		}
	},
	mounted () {
		document.addEventListener('click', this.clickOutside)
	},
}
</script>

<style lang="scss">
.dropdown-title {
	padding: 10px;
	cursor: pointer;
	text-transform: uppercase;
	border: 1px solid lightgrey;

	&.shown {
		border-color: #28354b;
	}
}

.dropdown-arrow {
	float: right;
}

.dropdown-container.row {
	position: relative;
	border: unset;
	width: unset;
}

.dropdown-container {
	border: 1px solid #28354b;
	background: white;
	color: #28354b;
	font-size: 12px;
	padding: 10px;
	position: absolute;
	z-index: 9;
	text-transform: uppercase;
	width: max-content;

	.right {
		@media (max-width: 488px) {
			right: 0;
		}
	}
}
</style>
